import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialFloatOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {color} from "@cm/graph-v3"

export interface SeparateHsvSockets extends MaterialNodeSockets {
    inputs: {
        image: "color" // found in inputs: color; found in settings: color; inferred from data: float3
    }
    settings: {
        color: "color" // found in inputs: -; found in settings: color; inferred from data: float3
        h: "float" // found in inputs: -; found in settings: float; inferred from data: float
        image: "color" // found in inputs: color; found in settings: color; inferred from data: float3
        s: "float" // found in inputs: -; found in settings: float; inferred from data: float
        v: "float" // found in inputs: -; found in settings: float; inferred from data: float
    }
    outputs: {
        h: "float"
        s: "float"
        v: "float"
    }
}

export const separateHsvDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeSeparateHSV,
    },
    nodeClass: "SeparateHsv",
    ui: {
        label: "Separate HSV",
        color: "#8d802f",
        items: [
            {name: "h", valueType: "float", label: "H", output: true},
            {name: "s", valueType: "float", label: "S", output: true},
            {name: "v", valueType: "float", label: "V", output: true},
            {name: "image", valueType: "color", label: "Image", input: true, setting: true, defaultValue: {r: 0.0, g: 0.0, b: 0.0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({h: materialFloatOutput, s: materialFloatOutput, v: materialFloatOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({image: optionalMaterialInput}),
            settings: z.strictObject({
                color: z.optional(color),
                h: z.optional(z.number()),
                image: z.optional(color),
                s: z.optional(z.number()),
                v: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<SeparateHsvSockets>
